import React, { useState, useEffect } from "react";
import {cargarClientes} from '../../services/apiClientes.js';
import '../../styles//form.css';
import '../../styles/botones_dflt.css';

const FiltrosClientes = ({ onBuscar }) => {
    const [optNombre, setOptNombre] = useState([]);
    const [optApellido, setOptApellido] = useState([]);
    const [optIdentificacion, setOptIdentificacion] = useState([]);
    const [filtros, setFiltros] = useState({
        nombre: '-1',
        apellido: '-1',
        cedula_ruc: '-1',
    });

    const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros({ ...filtros, [name]: value }); 
  };

    const handleBuscar = () => {
        onBuscar(filtros);
    };

    useEffect(() => {
        const fetchData = async () => {
          try {
            const jsonClientes = await cargarClientes(filtros);
            const clientesData = jsonClientes.clientes.map((item) => ({
              id: item.id,
              nombre: item.nombre,
              apellido: item.apellido,
              cedula_ruc: item.cedula_ruc,
              direccion: item.direccion
            }));
            //setOptClientes(clientesData);
            const nombresUnicos = Array.from(new Map(clientesData.map(item => [item.nombre, item])).values());
            setOptNombre(nombresUnicos);
            const apellidosUnicos = Array.from(new Map(clientesData.map(item => [item.apellido, item])).values());
            setOptApellido(apellidosUnicos);
            const identificacionesUnicos = Array.from(new Map(clientesData.map(item => [item.cedula_ruc, item])).values());
            setOptIdentificacion(identificacionesUnicos);
          } catch (error) {
            console.error('Error cargando las listas:', error);
          }
        };
        fetchData();
    },[]);

    return (
        <div className="crud-table-form">
            <div className="container">
                <div className='header-label'>
                    <label htmlFor="nombre">Nombre</label>
                    <select name="nombre" onChange={handleChange}>
                        <option key='-1' value='-1'>--Seleccione--</option>
                            {optNombre.map(opt => (
                                <option key={opt.nombre} value={opt.nombre}>{opt.nombre}</option>
                            ))}
                    </select>
                </div>
                <div className='header-label'>
                    <label htmlFor="apellido">Apellido</label>
                    <select name="apellido" onChange={handleChange}>
                        <option key='-1' value='-1'>--Seleccione--</option>
                            {optApellido.map(opt => (
                                <option key={opt.apellido} value={opt.apellido}>{opt.apellido}</option>
                            ))}
                    </select>
                </div>
                <div className='header-label'>
                    <label htmlFor="cedula_ruc">Identificación</label>
                    <select name="cedula_ruc" onChange={handleChange}>
                        <option key='-1' value='-1'>--Seleccione--</option>
                            {optIdentificacion.map(opt => (
                                <option key={opt.cedula_ruc} value={opt.cedula_ruc}>{opt.cedula_ruc}</option>
                            ))}
                    </select>
                </div>
            </div>
            <button className='button guardar' onClick={handleBuscar}>Buscar</button>
        </div>
    );
};

export default FiltrosClientes;